import {PNG_MIME_TYPE, SVG_MIME_TYPE} from "@/constants";

export function getImages(images) {
    let result = [];
    if (images) {
        result = images.map(file => ({
            url: file.url,
            width: file.width ?? 1024,
            height: file.height ?? 1024,
            filename: file.filename,
        }));
    }
    return result;
}

export function getUml(images) {
    let result = [];
    if (images) {
        const map = images.map(file => ({
            url: file.url,
            width: file.width ?? 1024,
            height: file.height ?? 1024,
            filename: file.filename,
            mime_type: file.mime_type
        }));
        // Сначала ищем SVG
        const svgImage = map.find(file => file.mime_type === SVG_MIME_TYPE);
        if (svgImage) {
            result = [svgImage];
        } else {
            // Если SVG не найден, ищем PNG
            const pngImage = map.find(file => file.mime_type === PNG_MIME_TYPE);
            if (pngImage) {
                result = [pngImage];
            }
        }
    }
    return result;
}

export function convertSvgToPng(svgUrl) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL(PNG_MIME_TYPE));
        };
        img.onerror = reject;
        img.src = svgUrl;
    });
}